import { RuleStatuses } from 'app/modules/rules/models';
import { IconEyeOff, IconScale } from '@u21/tabler-icons';
import { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<SVGElement> {
  status: RuleStatuses;
}

export const RuleIcon = ({ status, ...rest }: Props) => {
  if (status === 'ACTIVE_SHADOW') {
    return <IconEyeOff {...rest} />;
  }
  return <IconScale {...rest} />;
};
